import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import userStore from '../../store/user/user-store'
import ReactButton from './ReactButton.vue'
import statementStore from '../../store/statement/statement-store'

@Component({
  name: 'considerButton',
  props: ['statement'],
  components: { 'react-button' : ReactButton }
})
export default class ConsiderButton extends Vue {

  protected considerStatement (): void {
    statementStore.dispatchConsiderStatement(this.$props['statement'])
  }

  protected unconsiderStatement (): void {
    statementStore.dispatchUnconsiderStatement(this.$props['statement'])
  }

}
